// A site's own field (spec §8): the version holds `custom:<key>` and the site gives the component under the same key in
// `custom_fields`. The component receives: field, value, onChange, error, disabled, required, styles, form_values.
// Without a component for the key the field is a plain text box and a warning is printed once: the form never breaks.
import { h } from "../h.js";
import { CUSTOM_FIELD_PREFIX } from "../form_helper.js";
import { GRID_KEYS, grid_of } from "../constants.js";
import { TextualField } from "./textual.js";

const warned = new Set();

export const custom_key_of = (type) => String(type).slice(CUSTOM_FIELD_PREFIX.length);

// exported so tests can print the warning again
export const reset_custom_warnings = () => warned.clear();

export const CustomField = (props) => {
    const { field, value, on_change, error, required, disabled, styles, form_values, custom_fields, warn = (...args) => console.warn(...args) } = props;
    const Component = custom_fields?.[custom_key_of(field.type)];
    if (typeof Component === "function" || (Component && typeof Component === "object")) {
        return h(
            "div",
            { className: props.class_names?.[GRID_KEYS[grid_of(field)]], "data-field-type": field.type, "data-field-key": field.key },
            h(Component, { field, value, onChange: on_change, error, disabled, required, styles, form_values, id: props.id }),
        );
    }
    if (!warned.has(field.type)) {
        warned.add(field.type);
        warn(`[form-renderer] no component was given for the custom field "${field.type}" (custom_fields["${custom_key_of(field.type)}"]); it is shown as a text box.`);
    }
    return h(TextualField, { ...props, field: { ...field, type: "text" }, value: typeof value === "string" ? value : (value === undefined || value === null ? "" : String(value)) });
};
